import _isPlainObject from 'lodash/isPlainObject';

export function bRow(context, children) {
  return { is: 'b-row', ...context, children };
}

export function bCol(context, children) {
  return { is: 'b-col', ...context, children };
}

export function bRowCols(colContext, children) {
  if (typeof children.is === 'string') {
    children = [ children ];
  } else if (Array.isArray(children)) {
    children = children.filter(({ is }) => typeof is === 'string');
  } else if (_isPlainObject(children)) {
    children = Object.values(children).filter(({ is }) => typeof is === 'string');
  }

  return { is: 'b-row', children: children.map(child => ({ is: 'b-col', ...colContext, children: child })) };
}

export function bTwoCol({ left: lProps = {}, right: rProps = {} }, { left: lChildren, right: rChildren }) {
  return bRow({}, {
    left: bCol(lProps, lChildren),
    right: bCol(rProps, rChildren),
  });
}

export function bForm(context, children) {
  return { is: 'b-form', ...context, children };
}

export function bFormGroup(context, children) {
  return { is: 'b-formGroup', ...context, children };
}

export function bInput(context) {
  return { is: 'b-input', ...context };
}



// WEBPACK FOOTER //
// ./src/plugins/vue-form-bricks/bootstrap-vue.js